// @ts-ignore
import { jitsiLocalStorage } from '@jitsi/js-utils/jitsi-local-storage';
import { Button, Checkbox, FormControlLabel, InputAdornment, TextField } from '@mui/material';
import clsx from 'clsx';
import { now } from 'moment';
import React, { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { connect, useDispatch, useSelector } from 'react-redux';
import { makeStyles } from 'tss-react/mui';
import { LANDING_PAGE } from '../../../../../modules/API';
import { PAGE_AUTH, URL_POLICY } from '../../../../../modules/API/route';
import apiManagerRoom from '../../../api/apiManagerRoom';
import ApiManagerUser from '../../../api/ApiManagerUser';
import { reloadWithStoredParams } from '../../../app/actions.any';
import { waitForOwner } from '../../../authentication/actions.any';
import { clearErrorConference, setManualHandleError, setPassword, setRoomConfig, setRoomInfo, setRoomPasswordPrejoin, setRoomRoleParticipant } from '../../../base/conference/actions.web';
import { isGuestTmp } from '../../../base/conference/functions';
import { PREMEETING_BUTTONS, THIRD_PARTY_PREJOIN_BUTTONS } from '../../../base/config/constants';
import { isNameReadOnly, isNameValid } from '../../../base/config/functions.any';
import { ERROR_CODE_DISPLAY_NAME, ERROR_CODE_GET_DETAIL_ROOM, ERROR_CODE_JOIN_ROOM, STATUS_CODE_ROOM } from '../../../base/constants/apiCode';
import { CONFIG_CODE, GUEST_INFO } from '../../../base/constants/default';
import { openDialog } from '../../../base/dialog/actions';
import ConfirmDialog from '../../../base/dialog/components/web/ConfirmDialog';
import { IconClear, IconEyeHide, IconEyeShow, LogoColor } from '../../../base/icons/svg';
import { setJWT } from '../../../base/jwt/actions';
import { getJwtContext } from '../../../base/jwt/functions';
import { getLocalUserId, getLocalUserInfo, getRoleParticipant, hasModeratorRole } from '../../../base/participants';
import Preview from '../../../base/premeeting/components/web/Preview';
import LoadingIndicator from '../../../base/react/components/web/LoadingIndicator';
import { updateSettings } from '../../../base/settings/actions';
import { getDisplayName } from '../../../base/settings/functions.web';
import { withPixelLineHeight } from '../../../base/styles/functions.web';
import Tooltip from '../../../base/tooltip/components/Tooltip';
import ClickableIcon from '../../../base/ui/components/web/ClickableIcon';
import { parseURIString, parseURLParams } from '../../../base/util';
import { getAccessToken, setTokens } from '../../../base/util/cookies';
import { getConfigValue, homePage } from '../../../base/util/functions';
import isInsecureRoomName from '../../../base/util/isInsecureRoomName';
import { openDisplayNamePrompt } from '../../../display-name/actions';
import { setCloseDialog } from '../../../moderator-controller/slice';
import { showErrorNotification, showNotification, showWarningNotification } from '../../../notifications/actions.web';
import { NOTIFICATION_TIMEOUT_TYPE } from '../../../notifications/constants';
import Toolbox from '../../../toolbox/components/web/Toolbox';
import { isButtonEnabled } from '../../../toolbox/functions.web';
import { joinConference as joinConferenceAction } from '../../actions.web';
import { isDisplayNameRequired, isPrejoinDisplayNameVisible, isUnsafeRoomWarningEnabled } from '../../functions.any';
import { hasDisplayName } from '../../utils';
import WaitingForHost from './WaitingForHost';
import { disconnect } from '../../../base/connection/actions.any';
import { LOBBY_TYPE_NOTI } from '../../../lobby/constants';
import Spinner from '../../../base/react/components/web/LoadingIndicator';
import { initializeSocket } from '../../../conference/components/web/Conference';
const TIMEOUT_REJOIN = 1800000;
var timeoutPrejoin = undefined;
const useStyles = makeStyles()(theme => {
    return {
        container: {
            height: '100%',
            position: 'absolute',
            inset: '0 0 0 0',
            backgroundColor: theme.palette.ui10,
            zIndex: 252,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            '@media (max-width: 720px)': {
                flexDirection: 'column'
            },
            '& #preview': {
                width: `min(800px, 41.7vw)`,
                height: '450px',
                borderRadius: '20px',
                overflow: 'hidden',
                position: 'relative',
                maxWidth: '95%',
                '& div:has(.avatar)': {
                    margin: 'auto'
                },
                '@media (max-width: 720px)': {
                    width: '740px'
                },
                '& .toolbox-actions': {
                    position: 'absolute',
                    bottom: '10px',
                    left: 0,
                    right: 0,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    columnGap: '24px',
                    paddingTop: '20px',
                    paddingBottom: '20px'
                },
                '& .main-buttons': {
                    columnGap: '24px'
                },
                '& .toolbox-icon': {
                    backgroundColor: 'transparent',
                    '&:hover': {
                        backgroundColor: 'transparent'
                    },
                    '& div.jitsi-icon.jitsi-icon-default': {
                        backgroundColor: '#000000' + '32'
                    }
                },
                '& .settings-button-small-icon': {
                    backgroundColor: theme.palette.default00,
                    '& div.jitsi-icon.jitsi-icon-default': {
                        backgroundColor: '#000000' + '32'
                    }
                }
            }
        },
        header: {
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            padding: '28px 40px',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            '& svg': {
                height: '40px'
            }
        },
        prejoinContainer: {
            display: 'flex',
            flexDirection: 'column',
            height: 'calc(100vh - 96px)',
            marginTop: '96px',
            alignItems: 'center',
            rowGap: '32px',
            width: '100%',
            overflowY: 'auto',
            paddingBottom: '20px',
            '& #preview': {
                width: '298px',
                minHeight: 'calc(298px * 9 / 16)',
                height: 'calc(298px * 9 / 16)',
                alignItems: 'start',
                '& .defaultClassAvatar': {
                    margin: 'auto',
                    '&.jitsi-icon': {
                        margin: 'auto',
                        transform: 'unset'
                    }
                },
                '& .avatar': {
                    // marginTop: '16px',
                    width: '60px !important',
                    height: '60px !important',
                    fontSize: '24px !important'
                },
                '& .toolbox-actions': {
                    bottom: 0,
                    padding: 0,
                    '& .main-buttons': {
                        columnGap: '4px',
                        '& .item-toolbox-custom.toolbox-icon': {
                            minWidth: 'auto'
                        }
                    }
                },
                '@media (min-width: 580px)': {
                    width: '460px',
                    // height: '225px',
                    minHeight: 'calc(460px * 9 / 16)',
                    height: 'calc(460px * 9 / 16)',
                    '& .avatar': {
                        width: '120px !important',
                        height: '120px !important',
                        fontSize: '48px !important',
                        margin: 'auto',
                        // marginTop: '50px'
                    },
                },
                '@media (min-width: 1536px)': {
                    width: `min(740px, 38.6vw)`,
                    // height: '420px',
                    minHeight: 'calc(min(740px, 38.6vw) * 9 / 16)',
                    height: 'calc(min(740px, 38.6vw) * 9 / 16)',
                    '& .avatar': {
                        width: '200px !important',
                        height: '200px !important',
                        fontSize: '80px !important',
                        margin: 'auto',
                        // marginTop: '50px'
                    }
                }
            },
            '@media (min-width: 1024px)': {
                flexDirection: 'row',
                columnGap: 'min(max(5.21vw, 32px), 100px)',
                justifyContent: 'center',
                '& .toolbox-actions': {
                    bottom: '23px'
                }
            }
        },
        content: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            flexShrink: 0,
            boxSizing: 'border-box',
            position: 'relative',
            rowGap: '12px',
            width: '100%',
            padding: '0 24px',
            zIndex: 252,
            '@media (min-width: 580px)': {
                width: '460px',
                padding: 0
            },
            '@media (min-width: 1024px)': {
                width: '440px'
            },
        },
        contentControls: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            margin: 'auto',
            width: '100%'
        },
        title: {
            ...withPixelLineHeight(theme.typography.heading4),
            color: `${theme.palette.text01}!important`,
            marginBottom: theme.spacing(3),
            textAlign: 'center',
            '@media (max-width: 400px)': {
                display: 'none'
            }
        },
        roomName: {
            ...withPixelLineHeight(theme.typography.heading5),
            color: theme.palette.text01,
            marginBottom: theme.spacing(4),
            overflow: 'hidden',
            textAlign: 'center',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            width: '100%'
        },
        createAccountPolicy: {
            display: 'flex',
            alignItems: 'center',
            marginTop: '16px',
            fontSize: '18px',
            color: theme.palette.default00,
            width: '100%'
        },
        spotline: {
            color: theme.palette.primary10,
            fontStyle: 'normal',
            fontWeight: 600,
            cursor: 'pointer',
            fontSize: '16px',
            '&:hover': {
                textDecoration: 'none'
            },
            '&.spotlineNormal': {
                fontWeight: 500
            }
        },
        login: {
            color: theme.palette.default00,
            fontSize: '16px',
            textAlign: 'left',
            width: '100%',
            fontWeight: 500,
            '&.loginCenter': {
                textAlign: 'center'
            }
        },
        titleForm: {
            // fontFamily: 'FSPFBeauSansPro',
            fontWeight: 600,
            fontSize: '28px',
            color: theme.palette.default00
        },
        joiningRoom: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            rowGap: '24px'
        },
        outlineSecond: {
            borderColor: '#E0E0E0 !important',
            fontSize: '16px',
            fontWeight: 500,
            textDecoration: 'none'
        },
        fullWidth: {
            width: '100%'
        },
        joiningSpinner: {
            marginRight: 8
        }
    };
});
function storeGuestData(token, refreshToken) {
    localStorage.setItem("joinAsGuest", "yes");
    setTokens(token, refreshToken);
}
export async function handleGuestJoin(displayNameGuest) {
    localStorage.setItem(GUEST_INFO.DISPLAY_NAME, displayNameGuest || "");
    try {
        const result = await ApiManagerUser.guestJoin(displayNameGuest);
        if (result.data?.token) {
            storeGuestData(result.data?.token, result.data?.refreshToken);
            if (!webSocket?.id)
                initializeSocket();
            return true;
        }
    }
    catch (error) {
        if (error.response?.data?.data) {
            switch (error.response?.data?.data) {
                // case 'ROOM_NOT_START':
                //     console.log(localStorage.getItem('language') === "vi" ? "Cuộc họp không tồn lại, hoặc chưa diễn ra. Vui lòng liên hệ lại chủ trì." : "The meeting doesn't exist, or hasn't happened yet. Please contact the host again.")
                //     break;
                case 'RETRY':
                    // setTimeout(() => {
                    //     window.location.reload();
                    // }, 1000);
                    // console.log('RETRY')
                    break;
                default:
                    // alert(localStorage.getItem('language') === "vi" ? "Xin thử lại" : "Try again")
                    console.log("ERROR: ", error.response);
                    break;
            }
        }
        return false;
    }
}
const PrejoinV3 = ({ joinConference, _buttons, children, className, videoMuted, videoTrack, isDisplayNameVisible, readOnlyName, showErrorOnJoin, name, updateSettings: dispatchUpdateSettings, showUnsafeRoomWarning, unsafeRoomConsent }) => {
    const { classes } = useStyles();
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const [agreePolicy, setAgreePolicy] = useState(false);
    const [blurNameField, setBlurNameField] = useState(false);
    const [blurPasswordField, setBlurPasswordField] = useState(false);
    const [roomPassword, setRoomPassword] = useState('');
    const [disableRoom, setDisableRoom] = useState(false);
    const [isShowPassword, setIsShowPassword] = useState(false);
    const [manualNaviage, setManualNaviage] = useState(false);
    const [isLoaded, setIsLoaded] = useState(false);
    const [isJoining, setIsJoining] = useState(false);
    const { messages } = useSelector((state) => state['features/chat']);
    const { iAmRecorder } = useSelector((state) => state['features/base/config']);
    const showDisplayNameField = useMemo(() => isDisplayNameVisible && !readOnlyName, [isDisplayNameVisible, readOnlyName]);
    const showErrorOnField = useMemo(() => showDisplayNameField && showErrorOnJoin, [showDisplayNameField, showErrorOnJoin]);
    const isGuest = !getAccessToken() && !iAmRecorder;
    const isWaitingForOwner = useSelector((state) => Boolean(state['features/authentication'].waitForOwnerTimeoutID));
    const { password, passwordRequired, roomInfo, error, membersOnly, roomConfig, guestJoin } = useSelector((state) => state['features/base/conference']);
    const { joiningInProgress } = useSelector((state) => state['features/prejoin']);
    const { local } = useSelector((state) => state['features/base/participants']);
    const userRole = useSelector((state) => getRoleParticipant(state, local?.id));
    const isModerator = hasModeratorRole(userRole);
    const hasPassword = password || roomInfo?.password;
    const showPasswordField = useMemo(() => hasPassword && !roomPassword, [hasPassword, roomPassword]);
    const mustRequestJoin = ((isGuest || isGuestTmp()) && roomInfo?.type === STATUS_CODE_ROOM.NOT_START) || (roomInfo?.lobby && roomInfo?.userHostId !== getLocalUserInfo()?.username);
    const keyButtonJoin = mustRequestJoin ? 'prejoin.requestJoinMeeting' : 'prejoin.joinMeeting';
    const errorPassword = error?.name === ERROR_CODE_JOIN_ROOM.PASSWORD_REQUIRED;
    const nameValid = isNameValid(name);
    const _isNameValid = nameValid === ERROR_CODE_DISPLAY_NAME.OK;
    /**
     * Tham gia cuộc họp
     * B1: Chuyển đến màn hình đang tham gia
     * B2: Hiển thị thông tin phòng chờ
     * B3: Tham gia cuộc họp
     *
     * Lấy thông tin phòng, thông tin người dùng
     * If guest && not start => waiting
     * if lobby && password => waiting
     * if config => waiting
     */
    const joinRoom = async () => {
        dispatch(clearErrorConference());
        setManualNaviage(false); // tự naviage
        setIsLoaded(false); // dừng loading
        let _mustRequest = mustRequestJoin;
        // Nếu có lỗi
        if (showErrorOnJoin) {
            dispatch(openDisplayNamePrompt({
                onPostSubmit: joinConference,
                validateInput: hasDisplayName
            }));
            return;
        }
        if (isGuest) {
            await handleGuestJoin(name);
        }
        if (!roomInfo)
            _mustRequest = await getDetailRoom(true);
        if (!roomConfig) {
            const getConfigsSystem = async () => {
                try {
                    const configs = await apiManagerRoom.getConfigs();
                    if (configs && configs?.data) {
                        dispatch(setRoomConfig(configs?.data));
                    }
                }
                catch (error) {
                    console.log('[debugger] error getConfigsSystem: ', error);
                }
            };
            getConfigsSystem();
        }
        if (!localStorage.getItem(GUEST_INFO.DISPLAY_NAME) && isGuestTmp()) {
            localStorage.setItem(GUEST_INFO.DISPLAY_NAME, name);
            ApiManagerUser.updateDisplayname({ displayName: name });
        }
        const user = jitsiLocalStorage.getItem("user") && JSON.parse(jitsiLocalStorage.getItem("user"));
        if (!user?.displayName)
            ApiManagerUser.updateDisplayname({ displayName: name });
        if (_mustRequest?.hasPassword)
            return;
        /**
         * TODO:
         * Nếu phòng có mật khẩu
         * B1: Lưu mật khẩu
         * B2: Kiểm tra phòng chờ
         * B3: Tham gia với mật khẩu
         */
        if ((hasPassword && roomPassword) || errorPassword) {
            dispatch(setRoomPasswordPrejoin(roomPassword));
            if (_mustRequest?.mustRequest)
                return dispatch(waitForOwner());
            if (errorPassword)
                dispatch(setPassword(passwordRequired, passwordRequired?.join, roomPassword || password));
            else
                joinConference();
        }
        else {
            if ((roomInfo?.lobby || _mustRequest?.mustRequest) && !isModerator)
                dispatch(waitForOwner());
            return joinConference();
        }
    };
    const handleJoin = async () => {
        if (!guestJoin && isGuest) {
            return window.location.href = `${PAGE_AUTH}/auth/login?domain=${window.location.href}`;
        }
        setIsJoining(true);
        await joinRoom();
    };
    /**
     * Handle keypress on input.
     *
     * @param {KeyboardEvent} e - Keyboard event.
     * @returns {void}
     */
    const onInputKeyPress = (e) => {
        if (e.key === 'Enter') {
            if (isGuest) {
                if (!agreePolicy || showPasswordField || showErrorOnField || disableRoom || !_isNameValid)
                    return;
                return handleJoin();
            }
            if (showErrorOnField || showPasswordField || disableRoom || !_isNameValid)
                return;
            return handleJoin();
        }
    };
    /**
     * Sets the guest participant name.
     *
     * @param {string} displayName - Participant name.
     * @returns {void}
     */
    const setName = (displayName) => {
        dispatchUpdateSettings({
            displayName
        });
    };
    /**
     * TODO:
     * Lấy thông tin phòng
     * - Phòng không tồn tại -> toast error
     * - Phòng đã bị khóa -> toast notification
     * - Cuộc họp đã quá hạn -> toast error
     * - Cuộc họp riêng tư -> toast error
     * - Thành công -> set value store
     */
    const getDetailRoom = async (mustRequest = false) => {
        let location = parseURIString(window.location.href);
        try {
            const roomDetail = await apiManagerRoom.getDetailRoom(location?.room); // Gọi api
            if (roomDetail) {
                const _room = roomDetail?.data[0];
                // Phòng đã quá hạn
                if (_room?.isInstant !== 1 &&
                    _room?.type !== STATUS_CODE_ROOM.NOT_START &&
                    now() - (_room?.tsEnd * 1000) > 0) {
                    setDisableRoom(true);
                    return dispatch(showErrorNotification({
                        titleKey: 'getDetailRoom.overDueRoom',
                        descriptionKey: 'getDetailRoom.createNewRoom',
                        hideErrorSupportLink: true,
                        hideDismiss: true
                    }, NOTIFICATION_TIMEOUT_TYPE.STICKY));
                }
                /**
                 * TODO:
                 * Lấy thông tin owner, host, coHost
                 */
                const _roleInRoom = _room?.participant.map((p) => ({
                    id: p.id,
                    username: p.username,
                    role: p.role
                }));
                dispatch(setRoomRoleParticipant(_roleInRoom));
                /**
                 * TODO: Cuộc họp riêng tư
                 * - Kiểm tra thông tin cuộc họp
                 * - Kiểm tra thông tin người dùng
                 * - Thông báo
                 */
                if (_room?.meeting_mode === 1) {
                    const user = jitsiLocalStorage.getItem("user") && JSON.parse(jitsiLocalStorage.getItem("user"));
                    const userId = getLocalUserId();
                    const canJoin = _room?.participant.some((p) => (p?.username === user?.username) || (p?.id === userId));
                    if (isGuest || isGuestTmp() || !canJoin) {
                        setDisableRoom(true);
                        return dispatch(showErrorNotification({
                            titleKey: 'getDetailRoom.privateRoom',
                            descriptionKey: 'getDetailRoom.privateRoomDesc',
                            hideErrorSupportLink: true,
                            hideDismiss: true
                        }, NOTIFICATION_TIMEOUT_TYPE.STICKY));
                    }
                }
                // Thành công
                setDisableRoom(false);
                document.title = `${_room?.roomName} | Viettel Meeting Platform`;
                dispatch(setRoomInfo(_room));
                if (mustRequest) {
                    let isNotStart = _room?.type === STATUS_CODE_ROOM.NOT_START;
                    if (_room?.children) {
                        isNotStart = !_room.children.some((r) => r.type === STATUS_CODE_ROOM.PROGRESS);
                    }
                    return {
                        mustRequest: isNotStart && (isGuest || isGuestTmp()),
                        hasPassword: _room?.password
                    };
                }
            }
        }
        catch (error) {
            console.log('[debugger] error: ', error, error?.response?.data?.data);
            /**
             * TODO:
             * Trường hợp phòng không tồn tại -> Thông báo
             */
            if (error?.response?.data?.data === ERROR_CODE_GET_DETAIL_ROOM.ROOM_NOT_EXISTED) {
                setDisableRoom(true);
                dispatch(showErrorNotification({
                    titleKey: 'getDetailRoom.roomNotExisted',
                    hideErrorSupportLink: true,
                    hideDismiss: true
                }, NOTIFICATION_TIMEOUT_TYPE.STICKY));
            }
        }
    };
    /**
     * Xử lý tham gia lại cuộc họp với config và mật khẩu đã lưu
     */
    const handleRejoin = () => {
        setManualNaviage(true);
        dispatch(setCloseDialog());
        setTimeout(() => {
            dispatch(reloadWithStoredParams(roomPassword));
        }, 250);
    };
    /**
     * Lấy thông tin lỗi mật khẩu
     * @returns
     */
    const getErrorTextPassword = () => {
        if (joiningInProgress)
            return;
        if (!roomPassword && blurPasswordField)
            return t('prejoin.errorMissingPassword');
        if (errorPassword)
            return t('prejoin.errorWrongPassword');
        return;
    };
    /**
     * TODO:
     * Lấy thông tin người dùng đã đăng nhập
     * displayname
     * avatar
     */
    useEffect(() => {
        const localGuestDisplayName = localStorage.getItem(GUEST_INFO.DISPLAY_NAME);
        if (!isGuest) {
            if (isGuestTmp()) {
                return setName(localGuestDisplayName || "");
            }
            const context = getJwtContext(getAccessToken());
            if (context) {
                dispatch(setJWT(getAccessToken()));
            }
        }
        else {
            if (localGuestDisplayName)
                setName(localGuestDisplayName);
        }
    }, []);
    /**
     * Timout prejoin
     */
    useEffect(() => {
        if (joiningInProgress || ((isWaitingForOwner || membersOnly) && !manualNaviage)) {
            clearTimeout(timeoutPrejoin);
            timeoutPrejoin = setTimeout(() => {
                setIsLoaded(true);
                dispatch(disconnect());
                // open dialog
                dispatch(openDialog(ConfirmDialog, {
                    hideTooltip: true,
                    titleKey: 'prejoin.dialog.expiredTitle',
                    onCancel: () => homePage(false),
                    onSubmit: () => handleRejoin(),
                    children: React.createElement("p", null, t('prejoin.dialog.descExpiredTitle')),
                    ok: {
                        translationKey: 'prejoin.dialog.rejoin'
                    }
                }));
            }, parseInt(getConfigValue(CONFIG_CODE.DURATION_TIMOUT_PREJOIN, roomConfig)) || TIMEOUT_REJOIN);
        }
        if (errorPassword) {
            dispatch(setRoomInfo({ ...roomInfo, password: 1 }));
            clearTimeout(timeoutPrejoin);
            setIsJoining(false);
        }
        return () => {
            clearTimeout(timeoutPrejoin);
        };
    }, [joiningInProgress, errorPassword, isWaitingForOwner, membersOnly, manualNaviage, roomConfig]);
    /**
     * TODO:
     * Lắng nghe khóa phòng
     */
    useEffect(() => {
        const originalAlert = window.alert;
        window.alert = (message) => {
            if (message === ERROR_CODE_JOIN_ROOM.ROOM_LOCKED) {
                dispatch(setManualHandleError(true));
                // @ts-expect-error
                clearTimeout(window.alertDebounce);
                // @ts-expect-error
                window.alertDebounce = setTimeout(() => {
                    dispatch(showNotification({
                        titleKey: 'getDetailRoom.lockedRoom',
                        descriptionKey: 'getDetailRoom.contactHost',
                        customActionClose: () => {
                            setTimeout(() => {
                                dispatch(disconnect());
                                homePage(false);
                            }, 500);
                        }
                    }, NOTIFICATION_TIMEOUT_TYPE.STICKY));
                    dispatch(setManualHandleError(true));
                }, 500);
            }
        };
        return () => {
            window.alert = originalAlert;
        };
    }, []);
    /**
     * Lâý thông tin phòng
     */
    useEffect(() => {
        // Lấy thông tin mật khẩu và tự động điền
        const params = parseURLParams(location);
        if (params?.password) {
            setRoomPassword(params.password);
        }
        getDetailRoom();
    }, []);
    useEffect(() => {
        if (messages.length) {
            const newMessage = messages[messages.length - 1];
            if (newMessage?.lobbyChat) {
                if (newMessage.message === LOBBY_TYPE_NOTI.ROOM_LOCKED) {
                    dispatch(showNotification({
                        titleKey: 'getDetailRoom.lockedRoom',
                        descriptionKey: 'getDetailRoom.contactHost',
                        customActionClose: () => {
                            setTimeout(() => {
                                dispatch(disconnect());
                                homePage(false);
                            }, 500);
                        }
                    }, NOTIFICATION_TIMEOUT_TYPE.STICKY));
                }
                if (newMessage.message === LOBBY_TYPE_NOTI.ROOM_ENDED) {
                    dispatch(showWarningNotification({
                        titleKey: 'prejoin.toast.roomEnd',
                        hideDismiss: true,
                        customActionClose: () => {
                            setTimeout(() => {
                                homePage(false);
                            }, 500);
                        }
                    }, NOTIFICATION_TIMEOUT_TYPE.STICKY));
                }
            }
        }
    }, [messages]);
    return (React.createElement("div", { className: clsx('premeeting-screen', classes.container, className) },
        React.createElement("div", { className: clsx(classes.header) },
            React.createElement(Tooltip, { content: t('jitsiHome', { logo: 'Viettel Meeting' }), position: 'bottom' },
                React.createElement("a", { href: LANDING_PAGE, target: '_blank', "aria-label": t('jitsiHome', { logo: 'Viettel Meeting' }) },
                    React.createElement(LogoColor, null))),
            React.createElement(Button, { variant: 'outlined', onClick: () => homePage(false) }, t('dialog.close'))),
        (((isWaitingForOwner || membersOnly) && !manualNaviage) || isLoaded) ?
            React.createElement(WaitingForHost, { preview: (React.createElement(Preview, { videoMuted: videoMuted, videoTrack: videoTrack },
                    React.createElement("div", { className: 'toolbox-actions' }, _buttons.length && React.createElement(Toolbox, { toolbarButtons: _buttons })))), isRoomNotStart: roomInfo?.type === STATUS_CODE_ROOM.NOT_START, isLoaded: roomInfo?.accessDenied ?? isLoaded, roomInfo: roomInfo }) :
            React.createElement("div", { className: clsx(classes.prejoinContainer) },
                React.createElement(Preview, { videoMuted: videoMuted, videoTrack: videoTrack },
                    React.createElement("div", { className: 'toolbox-actions' }, _buttons.length && React.createElement(Toolbox, { toolbarButtons: _buttons }))),
                (joiningInProgress && !isModerator) ?
                    React.createElement("div", { className: clsx(classes.joiningRoom) },
                        React.createElement("h1", { className: clsx(classes.titleForm) }, t('prejoin.inJoining')),
                        React.createElement(LoadingIndicator, null)) :
                    React.createElement("div", { className: classes.content },
                        React.createElement("h1", { className: clsx(classes.titleForm) }, t('lobby.joinTitle')),
                        React.createElement(FormControlLabel, { label: t('lobby.nameFieldLable'), labelPlacement: 'top', required: true, control: React.createElement(TextField, { id: 'prejoin-enter-name', "data-size": 'normal', autoFocus: !errorPassword, fullWidth: true, placeholder: t('dialog.enterDisplayName'), error: (showErrorOnField && blurNameField) || (blurNameField && !_isNameValid), value: name, onChange: (e) => setName(e.target.value), onKeyPress: showUnsafeRoomWarning && !unsafeRoomConsent ? undefined : onInputKeyPress, onBlur: () => setBlurNameField(true), onFocus: () => setBlurNameField(false), helperText: (showErrorOnField && blurNameField && t('prejoin.errorMissingName')) ||
                                    (!_isNameValid && blurNameField && t(nameValid)), InputProps: {
                                    endAdornment: (React.createElement(React.Fragment, null, name &&
                                        React.createElement(InputAdornment, { position: 'end' },
                                            React.createElement(Tooltip, { content: t('textField.clear') },
                                                React.createElement(ClickableIcon, { accessibilityLabel: 'clear-input', icon: IconClear, onClick: () => setName(''), className: 'icon-input', onKeyPress: (e) => {
                                                        if (e?.key === 'Enter')
                                                            setName('');
                                                    } })))))
                                } }) }),
                        (hasPassword || errorPassword) && React.createElement(FormControlLabel, { label: t('lobby.passwordField'), labelPlacement: 'top', required: true, control: React.createElement(TextField, { autoFocus: errorPassword, fullWidth: true, "data-size": 'normal', placeholder: t('lobby.enterPasswordButton'), value: roomPassword, type: isShowPassword ? 'text' : 'password', onChange: (e) => {
                                    hasPassword && dispatch(clearErrorConference());
                                    setRoomPassword(e.target.value);
                                }, onKeyPress: (showUnsafeRoomWarning && !unsafeRoomConsent || isGuest) ? undefined : onInputKeyPress, onBlur: () => setBlurPasswordField(true), onFocus: () => {
                                    setBlurPasswordField(false);
                                }, error: hasPassword && blurPasswordField || errorPassword && !joiningInProgress, helperText: getErrorTextPassword(), InputProps: {
                                    endAdornment: (React.createElement(React.Fragment, null,
                                        React.createElement(InputAdornment, { position: 'end' },
                                            roomPassword && React.createElement(Tooltip, { content: t('textField.clear') },
                                                React.createElement(ClickableIcon, { accessibilityLabel: 'clear-input', icon: IconClear, onClick: () => setRoomPassword(''), className: 'icon-input', onKeyPress: (e) => {
                                                        if (e?.key === 'Enter')
                                                            setRoomPassword('');
                                                    } })),
                                            React.createElement(Tooltip, { content: isShowPassword ? t('textField.passwordShow') : t('textField.passwordHide') },
                                                React.createElement(ClickableIcon, { accessibilityLabel: 'show-hide-password', icon: isShowPassword ? IconEyeShow : IconEyeHide, onClick: () => setIsShowPassword(prev => !prev), className: 'icon-input', onKeyPress: (e) => {
                                                        if (e?.key === 'Enter')
                                                            setIsShowPassword(prev => !prev);
                                                    } })))))
                                } }) }),
                        (guestJoin && isGuest) ?
                            React.createElement(React.Fragment, null,
                                React.createElement("div", { className: clsx(classes.createAccountPolicy) },
                                    React.createElement(Checkbox, { checked: agreePolicy, onChange: e => setAgreePolicy(e.target.checked), onKeyDown: e => {
                                            if (e.key === "Enter") {
                                                e.preventDefault();
                                                e.stopPropagation();
                                                setAgreePolicy(!agreePolicy);
                                            }
                                        } }),
                                    React.createElement("span", { className: classes.login },
                                        t('regiter-sso-no-sso.i-agree'),
                                        " ",
                                        React.createElement("a", { className: clsx(classes.spotline), onClick: () => window.open(URL_POLICY) }, t('regiter-sso-no-sso.terms-conditions')),
                                        " ",
                                        t('regiter-sso-no-sso.and'),
                                        " ",
                                        React.createElement("a", { className: clsx(classes.spotline), onClick: () => window.open(URL_POLICY) }, t('regiter-sso-no-sso.privacy-policy')))),
                                React.createElement(Tooltip, { containerClassName: classes.fullWidth, content: !_isNameValid ? t('prejoin.disableTooltip.nameInvalid') :
                                        isJoining ? t('prejoin.disableTooltip.isJoining') :
                                            showErrorOnField || showPasswordField || disableRoom ? t('prejoin.disableTooltip.invalid') : '', alwaysVisible: !agreePolicy || showPasswordField || showErrorOnField || disableRoom || !_isNameValid || isJoining },
                                    React.createElement(Button, { id: 'prejoin-join-meeting', disabled: !agreePolicy || showPasswordField || showErrorOnField || disableRoom || !_isNameValid || isJoining, onClick: handleJoin, fullWidth: true, style: { marginTop: '12px' }, size: 'medium', title: 'Join meeting' },
                                        isJoining ? React.createElement(Spinner, { containerClass: classes.joiningSpinner }) : '',
                                        " ",
                                        t(keyButtonJoin))),
                                React.createElement(Button, { onClick: () => window.location.href = `${PAGE_AUTH}/auth/login?domain=${window.location.href}`, variant: 'outlined', className: classes.outlineSecond, size: 'medium', fullWidth: true }, t('guest.login') + ' ' + t('guest.loginMore')),
                                React.createElement("span", { className: clsx(classes.login, 'loginCenter') },
                                    React.createElement("a", { className: clsx(classes.spotline, 'spotlineNormal'), href: `${PAGE_AUTH}/auth/register?domain=${window.location.href}` }, t('guest.register')),
                                    " ",
                                    ' ' + t('guest.registerMore'))) :
                            React.createElement(Tooltip, { containerClassName: classes.fullWidth, content: !_isNameValid ? t('prejoin.disableTooltip.nameInvalid') :
                                    isJoining ? t('prejoin.disableTooltip.isJoining') :
                                        showErrorOnField || showPasswordField || disableRoom ? t('prejoin.disableTooltip.invalid') : '', alwaysVisible: showErrorOnField || showPasswordField || disableRoom || !_isNameValid || isJoining },
                                React.createElement(Button, { id: 'prejoin-join-meeting', onClick: handleJoin, disabled: showErrorOnField || showPasswordField || disableRoom || !_isNameValid || isJoining, fullWidth: true, style: { marginTop: '12px' }, size: 'medium' },
                                    isJoining ? React.createElement(Spinner, { containerClass: classes.joiningSpinner }) : '',
                                    " ",
                                    t(keyButtonJoin)))))));
};
/**
 * Maps (parts of) the redux state to the React {@code Component} props.
 *
 * @param {Object} state - The redux state.
 * @param {Object} ownProps - The props passed to the component.
 * @returns {Object}
 */
function mapStateToProps(state, ownProps) {
    const { hiddenPremeetingButtons } = state['features/base/config'];
    const { toolbarButtons } = state['features/toolbox'];
    const premeetingButtons = (ownProps.thirdParty
        ? THIRD_PARTY_PREJOIN_BUTTONS
        : PREMEETING_BUTTONS).filter((b) => !(hiddenPremeetingButtons || []).includes(b));
    const name = getDisplayName(state);
    const showErrorOnJoin = isDisplayNameRequired(state) && !name;
    const { room } = state['features/base/conference'];
    const { unsafeRoomConsent } = state['features/base/premeeting'];
    return {
        // For keeping backwards compat.: if we pass an empty hiddenPremeetingButtons
        // array through external api, we have all prejoin buttons present on premeeting
        // screen regardless of passed values into toolbarButtons config overwrite.
        // If hiddenPremeetingButtons is missing, we hide the buttons according to
        // toolbarButtons config overwrite.
        _buttons: hiddenPremeetingButtons
            ? premeetingButtons
            : premeetingButtons.filter(b => isButtonEnabled(b, toolbarButtons)),
        isDisplayNameVisible: isPrejoinDisplayNameVisible(state),
        readOnlyName: isNameReadOnly(state),
        showErrorOnJoin,
        name,
        showUnsafeRoomWarning: isInsecureRoomName(room) && isUnsafeRoomWarningEnabled(state),
        unsafeRoomConsent
    };
}
const mapDispatchToProps = {
    joinConference: joinConferenceAction,
    updateSettings
};
export default connect(mapStateToProps, mapDispatchToProps)(PrejoinV3);
